export default __webpack_public_path__ + "static/media/icon-landing-page.8eaa0936.svg";